export default class PortainerError {
  constructor(msg, err) {
    this.msg = msg;
    this.err = err;
  }
}
